import React from 'react';
import { connect } from 'react-redux';
import { Video } from 'grommet';
import { withNamespaces } from 'react-i18next';
import { withTheme } from 'styled-components';
import styles from './subscribe.module.scss';

import { Box, Text } from 'components/Wrapped';

const Subscribe = withNamespaces()(({ t: translate, size }) => {
  // const t = nestedTranslate(translate, 'sections');

  return (
    <>
      <Box
        className={styles.root}
        style={{
          margin: size === 'small' ? '0px' : undefined,
          padding: size === 'small' ? '0px' : undefined,
          height: size === 'small' ? '355px' : undefined,
        }}
      >
        <Box
          align="start"
          justify="center"
          pad="none"
          height="100%"
          width="100%"
          round={size === 'small' ? { corner: 'top', size: '15px' } : '15px'}
          className={styles.inner}
        >
          <Box
            pad="none"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 1,
            }}
          >
            <Video
              src="/assets/videos/subscribe_bg.mp4"
              controls={false}
              playsInline
              autoPlay
              loop
              mute
              type="video/mp4"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                objectFit: 'cover',
                objectPosition: size === 'small' ? '84% center' : undefined,
                width: '100%',
              }}
            />
          </Box>
          <Box
            pad={{
              vertical: '0px',
              horizontal: size === 'small' ? '0px' : '80px',
            }}
            direction="column"
            className={styles.textBlockWrapper}
          >
            <Box pad="none" width={{ max: '658px' }} className={styles.textBlock}>
              {size !== 'small' && (
                <>
                  <Text color="white" size="56px" weight="bold" margin={{ bottom: '20px' }} style={{ lineHeight: '56px' }}>
                    Присоединяйтесь к сообществу IBEX
                  </Text>
                  <Text color="#B4B6B7" size="20px" margin={{ bottom: '50px' }} style={{ lineHeight: '26px' }}>
                    Следите за нашими последними новостями
                  </Text>
                  {/* <Box direction="row" gap="16px" pad="none">
                    <ButtonNew
                      theme="gray"
                      label={<Image src="/assets/social-icons/x.svg" />}
                      width="44px"
                      height="44px"
                    />
                    <ButtonNew
                      theme="gray"
                      label={<Image src="/assets/social-icons/tg.svg" />}
                      width="44px"
                      height="44px"
                    />
                    <ButtonNew
                      theme="gray"
                      label={<Image src="/assets/social-icons/fb.svg" />}
                      width="44px"
                      height="44px"
                    />
                    <ButtonNew
                      theme="gray"
                      label={<Image src="/assets/social-icons/youtube.svg" />}
                      width="44px"
                      height="44px"
                    />
                    <ButtonNew
                      theme="gray"
                      label={<Image src="/assets/social-icons/m.svg" />}
                      width="44px"
                      height="44px"
                    />
                    <ButtonNew
                      theme="gray"
                      label={<Image src="/assets/social-icons/ds.svg" />}
                      width="44px"
                      height="44px"
                    />
                  </Box> */}
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      {size === 'small' && (
        <Box background="#000D14" align="center" pad={{ bottom: '60px' }}>
          <Text
            color="white"
            size="30px"
            weight="500"
            margin={{ bottom: '12px', top: '28px' }}
            style={{ lineHeight: '30px', textAlign: 'center' }}
          >
            Присоединяйтесь <br /> к сообществу IBEX
          </Text>
          <Text color="#B4B6B7" size="16px" margin={{ bottom: '30px' }} style={{ lineHeight: '20.8px' }}>
            Следите за нашими последними новостями
          </Text>
        </Box>
      )}
    </>
  );
});

const mapStateToProps = ({
  exchangeSettings: {
    settings: {
      seo: { reCaptchaKey },
    },
  },
}) => ({ reCaptchaKey });

export default withTheme(connect(mapStateToProps)(Subscribe));
